import { createUseStyles } from 'react-jss'

import { colors } from 'components/common'

const useOptionSelectStyles = createUseStyles({
  optionSelectWrapper: {
    display: 'flex',
    flexDirection: 'column',
    '& > label': {
      fontWeight: 'bold',
      color: colors.gray600,
      fontSize: 12,
      marginBottom: '0.5rem'
    },
    '& .icon.add-category': {
      fontWeight: 'bold',
      color: colors.gray300,
      fontSize: 16,
      marginLeft: '0.5rem',
      padding: '0.5rem',
      cursor: 'pointer',

      '&:hover': {
        backgroundColor: colors.gray200,
        borderRadius: '100%'
      }
    },
    '& .active': {
      backgroundColor: colors.primary1,
      color: '#fff',
      borderRadius: '4px'
    }
  }
})

export { useOptionSelectStyles }
